import { Sentry } from '@/shared/lib/sentry';
import type { ClientTelemetryEventName } from '@aegislab/shared';
import { sendTelemetryEvent } from './sendTelemetryEvent';
import type { TelemetryPayload } from './types';

/**
 * 계측 이벤트 발화.
 *
 * 출구는 셋이다:
 * - DEV console — 개발 중 눈으로 확인
 * - Sentry breadcrumb — 오류가 잡혔을 때 직전 행동 맥락
 * - 서버 적재 — 나중에 질의하기 위한 유일한 경로. 앞의 둘은 정상 경로에서 아무것도
 *   남기지 않는다(breadcrumb 은 Sentry event 에 딸려야만 전송된다).
 */
export function trackEvent(name: ClientTelemetryEventName, payload: TelemetryPayload = {}): void {
  if (import.meta.env.DEV) {
    console.info(`[telemetry] ${name}`, payload);
  }
  Sentry.addBreadcrumb({
    category: 'telemetry',
    message: name,
    level: 'info',
    data: payload,
  });
  sendTelemetryEvent(name, payload);
}
